var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "relative ml-2 inline-block align-middle top-1"
  }, [_vm.isArray != null ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.isArray,
      expression: "isArray"
    }],
    staticClass: "appearance-none bg-opacity-25 h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-gray-600 border-2 rounded",
    attrs: {
      "name": _vm.name,
      "type": "checkbox",
      "necessary": _vm.necessary
    },
    domProps: {
      "value": _vm.name,
      "checked": Array.isArray(_vm.isArray) ? _vm._i(_vm.isArray, _vm.name) > -1 : _vm.isArray
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.isArray,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.name,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isArray = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.isArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.isArray = $$c;
        }
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }],
    staticClass: "appearance-none bg-opacity-25 h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-gray-600 border-2 rounded",
    attrs: {
      "name": _vm.name,
      "type": "checkbox",
      "necessary": _vm.necessary
    },
    domProps: {
      "checked": Array.isArray(_vm.mutableValue) ? _vm._i(_vm.mutableValue, null) > -1 : _vm.mutableValue
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.mutableValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mutableValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.mutableValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.mutableValue = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pointer-events-none absolute inset-x-1 inset-y-1.5"
  }, [_vm.mutableValue ? _c('icon', {
    staticClass: "font-semibold text-gray-600",
    attrs: {
      "name": "checkmark",
      "width": "12px",
      "height": "8px"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm.libelle != null ? _c('label', {
    class: 'text-2sm sm:text-' + _vm.sizeText + ' text-' + _vm.colorText + ' font-' + _vm.weightText + ' absolute px-2 py-1',
    attrs: {
      "for": _vm.name
    },
    on: {
      "click": function ($event) {
        _vm.mutableValue = !_vm.mutableValue;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.libelle) + "\n  ")]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }